import { getByUserId } from "../../../../actions/UserConfigurationActions";
import { GET_BY_USER_ID_CONFIGURATION } from "../../../../actions/types";
import ListGroup from 'react-bootstrap/ListGroup';
import { Col, Row, Form } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import { Close } from "@material-ui/icons";
import React, { Component } from "react";
import Card from 'react-bootstrap/Card';
import { connect } from "react-redux";

class UserConfigurationModal extends Component {

    state = {
		enableConfigurationEmail: false,
		userConfigurationId:      null,
		confirmationEmails:       [],
        errorEmail:               '',
		userData:                 null,
        userId:                   null,
        email:                    '',
	}

    constructor(props) {
		super(props);
		this.onPressEsc                           = this.onPressEsc.bind(this);
		this.handleChangeEnableConfigurationEmail = this.handleChangeEnableConfigurationEmail.bind(this);
		document.addEventListener('keydown', this.onPressEsc, false);
	}
    
    componentDidUpdate(prevProps) {
        if (this.state.userData !== this.props.userData) {
			this.setState({
				userData: this.props.userData
			});
			if(this.props.userData !== null){
                this.setState({
                    userId: this.props.userData._id
                })
				this.props.getByUserId(this.props.userData._id);
			}
		} else if (this.props.actionType === GET_BY_USER_ID_CONFIGURATION &&
            this.props.userConfiguration !== null && this.state.userConfigurationId !== this.props.userConfiguration._id
        ) {
			this.setState({
				userConfigurationId:      this.props.userConfiguration._id,
				enableConfigurationEmail: this.props.userConfiguration.mailing.ticket_confirmation.enable,
				confirmationEmails:       this.props.userConfiguration.mailing.ticket_confirmation.bcc
			});
		}
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onPressEsc, false);
    }

    onPressEsc(event) {
		if (event.keyCode === 27) {
			this.onPressCancel();
		}
	}

    async preparateUpdate() {
		const userConfiguration = {
			id:      this.state.userConfigurationId,
            mailing: {
                ticket_confirmation: {
                    enable: this.state.enableConfigurationEmail,
                    bcc:    this.state.confirmationEmails
                }
            }
		};
		this.props.handleUpdate(userConfiguration);
        this.emailForm.value = null;
	}

    onPressCancel() {
        this.setState(
			{
                userData:            null,
                errorEmail:          '',
                email:               '',
                confirmationEmails:  [],
                userConfigurationId: null,
				userConfiguration:   null
			},
			() => {
				this.props.handleCancel();
			}
		);
	}

    handleChangeEnableConfigurationEmail(evt) {
		this.setState({
			enableConfigurationEmail: evt.target.checked
		});
	}

    onChangeEmail(e) {
		this.setState({
			email: e.target.value,
		})
	}

    clearErrors() {
		this.setState({
			errorEmail: null
		})
	}

    addEmail() {
        this.clearErrors();
        if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(this.state.email)){
            this.setState({
                confirmationEmails: [...this.state.confirmationEmails, this.state.email],
                email:              ''
            });
        } else {
            this.setState({
                errorEmail: "Ingrese un correo valido."
            });
        }
    }

    deleteEmail(i) {
        this.setState({
            confirmationEmails: this.state.confirmationEmails.filter((email, index) => i !== index)
        })
    }

    render() {
		const title = "CONFIGURACIÓN DE USUARIO";
		return (
			<div className={
                this.props.isVisible ? "modal display-block" : "modal display-none"
            }>
                <div className="modal-center-main">
                        <div className="auth-group" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                            <center>{title}</center>
                            <div className="auth-label"></div>
                            <div className="auth-label"></div>
                            <br></br>
                            <Row>
                                <Col xs={12} md={12} sm={12} lg={12}>
                                    <Card>
                                        <Card.Header>Envío de correos de confirmación</Card.Header>
                                        <Card.Body>
                                            <Form>
                                                <Form.Check
                                                    onChange={this.handleChangeEnableConfigurationEmail}
                                                    checked={this.state.enableConfigurationEmail}
                                                    type={"checkbox"}
                                                    id={"check-enable-email"}
                                                    label={"Habilitar correo de configuración por cliente."}
                                                />
                                                <br></br>
                                                <div className="auth-label">
                                                    Agrega un nuevo correo para enviar copia de confirmación:
                                                    <input
                                                        id="emailForm"
                                                        ref={(el) => { this.emailForm = el }}
                                                        onChange={this.onChangeEmail.bind(this)}
                                                        value={this.state.email}
                                                        error={this.state.errorEmail}
                                                        type="title"
                                                        placeholder="Ej.: usuario@gmail.com"
                                                        className="local-store-input"
                                                    />
                                                </div>
                                                <div className="auth-error">
                                                    {this.state.errorEmail}
                                                </div>
                                                <Button variant="info" style={{marginTop: '2px'}} onClick={this.addEmail.bind(this)}>Agregar correo</Button> 
                                                <br></br><br></br>
                                                { this.state.confirmationEmails.length > 0 &&
                                                    <h5>Correos de confirmación:</h5>
                                                }
                                                <Card>
                                                    <ListGroup variant="flush">
                                                        {this.state.confirmationEmails.map((email, i) => (
                                                            <ListGroup.Item key={i} style={{fontSize: '14px'}}>
                                                                <Row>
                                                                    <Col xs={10} md={10} sm={10} lg={10}>
                                                                        {email}
                                                                    </Col>
                                                                    <Col xs={2} md={2} sm={2} lg={2}>
                                                                        <Close 
                                                                            size="small" 
                                                                            style={{color:"red", cursor:"pointer"}}
                                                                            onClick={() => this.deleteEmail(i)}
                                                                        >
                                                                            Cerrar
                                                                        </Close>
                                                                    </Col>
                                                                </Row>
                                                            </ListGroup.Item>
                                                        ))}
                                                    </ListGroup>
                                                </Card>
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                            <br></br>
                            <div className="modal-activity-section">
                                <button disabled={!this.state.userId} className="modal-buttonOK" onClick={this.preparateUpdate.bind(this)}>
                                    GUARDAR
                                </button>
                                {
                                    <button className="modal-buttonNo" onClick={this.onPressCancel.bind(this)}>
                                        CERRAR
                                    </button>
                                }
                            </div>
                        </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => ({
	actionType:        state.user_configuration_reducer.actionType,
	userConfiguration: state.user_configuration_reducer.userConfiguration,
	error:             state.user_configuration_reducer.error,
});

export default connect(mapStateToProps, 
	{
		getByUserId
	}
)(UserConfigurationModal);